import type { FC, ReactElement } from "react";

import type { IconName } from "@similarweb/icons";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

import {
    StyledComplexChipActions,
    StyledComplexChipContainer,
    StyledComplexChipContent,
    StyledComplexChipHeader,
    StyledComplexChipTitle,
    StyledIconButton,
} from "./styles";

export interface IFiltersComplexChipProps {
    children: ReactElement | ReactElement[];
    title: Readonly<Translatable>;
    actionIcon?: IconName;
    hideActionButton?: boolean;
    isDisabled?: boolean;
    onActionClick?: () => void;
    onRemove?: () => void;
}

export const FiltersComplexChip: FC<IFiltersComplexChipProps> = ({
    children,
    title,
    actionIcon = "edit-icon",
    hideActionButton = false,
    isDisabled,
    onActionClick,
    onRemove,
}): ReactElement => {
    return (
        <StyledComplexChipContainer isDisabled={isDisabled}>
            <StyledComplexChipHeader>
                <I18n
                    translatable={title}
                    element={StyledComplexChipTitle}
                />
                {hideActionButton ? null : (
                    <StyledComplexChipActions>
                        {onActionClick ? (
                            <StyledIconButton
                                iconName={actionIcon}
                                iconSize="xs"
                                type="flat"
                                isDisabled={isDisabled}
                                onClick={onActionClick}
                            />
                        ) : null}
                        {onRemove ? (
                            <StyledIconButton
                                iconName="clear-circle"
                                iconSize="xs"
                                type="flat"
                                isDisabled={isDisabled}
                                onClick={onRemove}
                            />
                        ) : null}
                    </StyledComplexChipActions>
                )}
            </StyledComplexChipHeader>
            <StyledComplexChipContent>{children}</StyledComplexChipContent>
        </StyledComplexChipContainer>
    );
};
